// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "ion-grid {\n  --ion-grid-padding: 0;\n}\nion-grid ion-row {\n  margin-left: -0.125rem;\n  margin-right: -0.125rem;\n}\nion-grid ion-row ion-col {\n  --ion-grid-column-padding-xs: 0.125rem;\n}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
